export const POSTS_PER_PAGE = 8;

export const PostsEndpoints = {
  getPostDetails: (id: number) => `rest/v1/news/${id}/secure`,
  getPostDetailsPublic: (id: number) => `rest/v1/news/${id}`,
  getSchedulePost: (postId: number) => `rest/v1/membership/posts/${postId}/scheduled`,
  getSchedulePosts: (postId: number) => `/rest/v1/collections/${postId}/news/scheduled`,
  postPinPost: (postId: number) => `/rest/v1/news/${postId}/pin`,
  postUnpinPost: (postId: number) => `/rest/v1/news/${postId}/unpin`,
  postCreatePublication: () => '/rest/v1/membership/posts',
  blockCommentsPost: (postId: number) => `rest/v1/news/${postId}`
};
